import { namespace } from '../constants'
import { prop, compose, equals } from 'ramda'

const root = prop(namespace)
export const network = compose(prop('network'), root)

export const isLoading = (state, action) =>
  equals(action, prop('loading', network(state)))
